'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const PasswordHiddenIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="PasswordHiddenIcon">
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.2936 8.92969C20.7207 9.95459 22.0138 11.154 23.143 12.5C24.2722 13.846 18.1677 18.7552 12.0568 18.7552C11.076 18.7381 10.1031 18.576 9.1698 18.274"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.0912 17.4658C4.7579 16.217 2.6865 14.5311 0.989902 12.5001C-0.706698 10.4691 5.946 6.24487 12.0568 6.24487C13.7903 6.27947 15.4913 6.72117 17.0225 7.53437"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9062 12.5C15.9062 14.6259 14.1827 16.3493 12.0568 16.3494"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.4396 3.11719L2.674 21.8828"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.3334 15.2234C7.2369 13.1269 8.1961 9.54714 11.06 8.77974C12.3891 8.42364 13.8073 8.80364 14.7803 9.77664"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

PasswordHiddenIcon.propTypes = {
  sx: PropTypes.object
}
